export enum DataDogEnvsEnum {
	DEV = 'dev',
	HML = 'hml',
	PROD = 'producao',
}
